
import { useQuery } from "@tanstack/react-query";
import { BlogPost } from "@/types/blogTypes";
import { mockBlogPosts } from "@/data/mockBlogPosts";

export function useBlogPosts() {
  const { data: posts = [], isLoading, error } = useQuery({
    queryKey: ['blog-posts'],
    queryFn: async () => {
      // In a real app, fetch from an API
      // return await fetch('/api/blog-posts').then(res => res.json());
      
      // For now, return mock data with a delay to simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockBlogPosts;
    },
  });
  
  // Extract unique categories
  const categories = Array.from(new Set(posts.map(post => post.category).filter(Boolean))) as string[];
  
  return {
    posts,
    categories,
    isLoading,
    error,
  };
}
